import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumb, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderCopyButton, HeaderOrganizationMenu } from '@/ui/components/header';
import { MainScrollArea } from '@/ui/components/main';
import { Icon } from '@/ui/components/icon';
import { CheckmarkBadge01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { NotFound } from '@/ui/components/not-found';
import { Spinner } from '@/ui/components/spinner';
import { CuratorList } from '@/features/curator/components/curator-list';
import { curatorAccessQuery } from '@/features/curator/queries';
import { useQuery } from '@tanstack/react-query';

export const Route = createFileRoute('/_authed/settings/internal/curator')({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } = useQuery(curatorAccessQuery());

  if (isPending) return <Spinner kind="inset" />;
  if (!data?.isCurator) return <NotFound />;

  return (
    <>
      <Header>
        <HeaderOrganizationMenu />
        <Breadcrumb>
          <BreadcrumbPage>
            <Icon icon={CheckmarkBadge01Icon} />
            Curator
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderCopyButton />
      </Header>
      <MainScrollArea>
        <CuratorList />
      </MainScrollArea>
    </>
  );
}
